import * as React from "react";
import {
  Button,
  useRecordContext,
  useRedirect,
  useResourceContext,
} from "react-admin";
import IconAudit from "@mui/icons-material/History";

/**
 * Opens the record's audit page. `resource` overrides the current one for views
 * whose resource name differs from the audited path (restaurant drafts).
 */
export const AuditButton = ({ resource }) => {
  const record = useRecordContext();
  const currentResource = useResourceContext();
  const redirect = useRedirect();
  const auditedResource = resource || currentResource;

  if (!record) return null;

  return (
    <Button
      label="Historial"
      onClick={() => redirect(`/${auditedResource}/${record.id}/audits`)}
    >
      <IconAudit />
    </Button>
  );
};

export default AuditButton;
